<!-- 逾期約定償還協議清單 -->
<template>
    <div class="row">
        <div class="col-12">
            <ListForm
                api="AssnUser"
                labelPosition="top"
                formTitle="逾期約定償還協議清單"
                :rules="rules"
                :recordToEdit="recordToEdit"
                :formType="formType"
            >
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="print">查詢</el-button>
                    <el-button type="primary" class="mb10" plain @click="print('pdf')">列印</el-button>
                    <!-- 查詢結果 -->
                    <el-table :data="tableData" v-if="showList" max-height="600" stripe border>
                        <el-table-column type="index" align="center" width="50" fixed></el-table-column>
                        <el-table-column
                            v-for="(item,index) in columns"
                            :prop="item.prop"
                            :label="item.label"
                            :key="index"
                            width="180"
                        >
                            <template slot-scope="scope">
                                <custom-row
                                    :scope="scope"
                                    :renderFunction="item.renderFunction"
                                    v-if="item.renderFunction"
                                ></custom-row>
                                <div v-else-if="item.addcomma">{{ $addcomma(scope.row[item.prop]) }}</div>
                                <div
                                    v-else-if="item.transferDate"
                                >{{ $transferDate(scope.row[item.prop]) }}</div>
                                <div v-else>{{ scope.row[item.prop] }}</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </ListForm>
            <div class="show-container">
                <div class="show"></div>
            </div>
        </div>
    </div>
</template>
<script>
import ListForm from "@/components/ListForm.vue";
import { API } from "@/assets/config";

export default {
    name: "agreement_repayment",
    components: { ListForm },
    data() {
        return {
            recordToEdit: {
                type: 1,
                accountStart: "",
                accountEnd: "",
                projectCode: {},
                loanStartDate: "",
                loanEndDate: ""
            },
            formType: [
                {
                    label: "篩選選擇",
                    key: "type",
                    type: "radio",
                    options: [
                        {
                            label: "起訖帳號",
                            value: 1
                        },
                        {
                            label: "貸款方案",
                            value: 2
                        },
                        {
                            label: "貸款日期",
                            value: 3
                        }
                    ]
                },
                {
                    label: "起訖帳號",
                    key: ["accountStart", "accountEnd"],
                    returnKey: "account",
                    type: "chooseMemberRange",
                    vif: true
                },
                {
                    label: "貸款方案",
                    key: "projectCode",
                    type: "select",
                    returnType: "object",
                    options: [],
                    vif: false
                },
                {
                    label: "貸款日期-起",
                    key: "loanStartDate",
                    type: "date",
                    vshow: false,
                    require: true
                },
                {
                    label: "貸款日期-迄",
                    key: "loanEndDate",
                    type: "date",
                    vshow: false,
                    require: true
                },
                {
                    label: "貸款結餘日期 ( 貸款基準日 )",
                    key: "balanceDate",
                    type: "date",
                    require: true
                },
                {
                    label: "資料排序方式",
                    key: "sortType",
                    type: "radio",
                    options: []
                },
                {
                    label: "資料過濾條件",
                    key: "filterType",
                    type: "radio",
                    options: []
                }
            ],
            rules: {
                name: [
                    {
                        required: true,
                        message: "請輸入方案名稱",
                        trigger: "blur"
                    }
                ]
            },
            columns: [
                {
                    prop: "agreementCode",
                    label: "協議編號"
                },
                {
                    prop: "account",
                    label: "帳號"
                },
                {
                    prop: "name",
                    label: "姓名"
                },
                {
                    prop: "iouNumber",
                    label: "借據號"
                },
                {
                    prop: "iouDateStart",
                    label: "貸款日期",
                    transferDate: true
                },
                {
                    prop: "principalEndDate",
                    label: "到期日期",
                    transferDate: true
                },
                {
                    prop: "withdrawalTotalAmount",
                    label: "貸款金額",
                    addcomma: true
                },
                {
                    prop: "normalAnnualRate",
                    label: "貸款利率"
                },
                {
                    prop: "installmentMonths",
                    label: "延期月數"
                },
                {
                    prop: "agreementDate",
                    label: "協議日期",
                    transferDate: true
                },
                {
                    prop: "iouAmount",
                    label: "協議次數"
                },
                {
                    prop: "coopLoanIouAgrPrincipalAmount",
                    label: "協議金額",
                    addcomma: true
                },
                {
                    prop: "coopLoanIouAgrPrincipalRate",
                    label: "協議利率"
                },
                {
                    prop: "coopLoanIouAgrPrincipalInstallmentNumbers",
                    label: "協議期數"
                },
                {
                    prop: "coopLoanIouAgrPrincipalInstallmentAmount",
                    label: "期還金額",
                    addcomma: true
                },
                {
                    prop: "coopLoanIouAgrBackpayAmountInterest",
                    label: "前欠利息",
                    addcomma: true
                },
                {
                    prop: "coopLoanIouAgrBackpayAmountDefault",
                    label: "前欠違約",
                    addcomma: true
                },
                {
                    prop: "coopLoanIouAgrBackpayAmountOther",
                    label: "前欠費用",
                    addcomma: true
                },
                {
                    prop: "loanBalance",
                    label: "貸款結餘",
                    addcomma: true
                },
                {
                    prop: "sumLoanBalance",
                    label: "貸餘合計",
                    addcomma: true
                }
            ],
            tableData: [],
            showList: false
        };
    },
    created() {
        this.getEnumData();
    },
    watch: {
        recordToEdit: {
            handler: function(newValue) {
                if (newValue.type == 3) {
                    this.formType[1].vif = false;
                    this.formType[2].vif = false;
                    this.formType[3].vshow = true;
                    this.formType[4].vshow = true;
                    this.recordToEdit.accountStart = "";
                    this.recordToEdit.accountEnd = "";
                } else {
                    this.formType[1].vif = false;
                    this.formType[2].vif = false;
                    this.formType[3].vshow = false;
                    this.formType[4].vshow = false;
                    this.formType[newValue.type].vif = true;
                }
            },
            deep: true
        }
    },
    methods: {
        getEnumData() {
            const url =
                API.CoopReport + `?action=OverdueRepaymentAgreementsListEnum`;

            const thenCB = json => {
                // 貸款方案
                this.formType[2].options = json.resultData.coopLoanProject;
                // 資料排序方式
                this.formType[6].options = json.resultData.sort;
                // 資料過濾條件
                this.formType[7].options = json.resultData.filter;
            };
            this.mAxiosGet(url, thenCB);
        },
        print(type) {
            try {
                this.check();
            } catch (error) {
                this.$message.error(error.message);
                return;
            }
            let date =
                parseInt(
                    $(`.balanceDate`)
                        .val()
                        .split("-")[0]
                ) +
                1911 +
                $(`.balanceDate`)
                    .val()
                    .slice(3);

            const url = API.CoopReport;
            // get 參數
            const params = {
                action: "OverdueRepaymentAgreementsList",
                balanceDate: date || "",
                sortType: this.recordToEdit.sortType || "",
                filterType: this.recordToEdit.filterType || ""
            };
            // 依照條件 get
            if (this.recordToEdit.type == 1) {
                params.accountStart = this.recordToEdit.accountStart || "";
                params.accountEnd = this.recordToEdit.accountEnd || "";
            } else if (this.recordToEdit.type == 2) {
                params.projectCode = this.recordToEdit.projectCode.code || "";
            } else if (this.recordToEdit.type == 3) {
                let loanStartDate =
                    parseInt(
                        $(`.loanStartDate`)
                            .val()
                            .split("-")[0]
                    ) +
                    1911 +
                    $(`.loanStartDate`)
                        .val()
                        .slice(3);
                let loanEndDate =
                    parseInt(
                        $(`.loanEndDate`)
                            .val()
                            .split("-")[0]
                    ) +
                    1911 +
                    $(`.loanEndDate`)
                        .val()
                        .slice(3);
                params.loanStartDate = loanStartDate || "";
                params.loanEndDate = loanEndDate || "";
            }

            if (type == "pdf") {
                // pdf
                params.action = "OverdueRepaymentAgreementsListPdf";
                this.mIframePDF(url, params);
            } else {
                // list
                this.showList = false;
                this.tableData = [];
                const thenCB = json => {
                    this.showList = true;
                    this.tableData = Object.assign(
                        [],
                        this.tableData,
                        json.resultData.data
                    );
                };
                this.mAxiosGet(url, thenCB, params, true);
            }
        },
        check() {
            if (this.recordToEdit.type == 1 && !this.recordToEdit.balanceDate) {
                this.$message.closeAll();
                throw new Error("請選擇貸款結餘日期");
            }
            if (this.recordToEdit.type == 3) {
                this.$message.closeAll();
                if (!this.recordToEdit.loanStartDate) {
                    throw new Error("請選擇貸款日期-起");
                } else if (!this.recordToEdit.loanEndDate) {
                    throw new Error("請選擇貸款日期-迄");
                } else if (!this.recordToEdit.balanceDate) {
                    throw new Error("請選擇貸款結餘日期");
                }
            }
        }
    }
};
</script>